<div class="!pr-[40px] !mb-[60px] flex">
  <div class="!w-[100%]">
    <div class="h-auto">
      <div class="container flex !pt-[15px]">
        <h3 class="!text-[20px] !text-[#000000] !font-bold !pl-[20px]">
          LIST OF SUBMISSIONS
        </h3>
      </div>
    </div>

    <app-filter-tool></app-filter-tool>

    <table class="w-full bg-[#fcfcfd] table-auto !mt-[20px]">
      <thead
        class="h-[52px] bg-[#DEE2E6] text-[#000000] !text-center justify-center !p-[20px]"
      >
        <tr>
          <th class="px-4 text-left w-[160px] header-field">RFI No.</th>
          <th class="px-4 text-left w-auto header-field">Title</th>
          <th
            class="px-4 text-left w-auto header-field"
            style="text-align: center"
          >
            Issued
          </th>
          <th
            class="px-4 text-left w-auto header-field"
            style="text-align: center"
          >
            Response Date
          </th>
          <th class="px-4 text-left w-auto header-field">Subject</th>
          <th class="px-4 text-center w-auto header-field">Action</th>
        </tr>
      </thead>
      <tbody class="!text-center">
        <ng-container *ngFor="let rfi of tableData; let i = index">
          <tr
            class="hover:bg-[#fae8e1] border-b-0"
            [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-[#DEE2E6]': i % 2 !== 0 }"
          >
            <td
              class="border-b-0 pr-4 pl-[1rem] py-2 w-auto cursor-pointer text-left whitespace-nowrap"
              (click)="openView(rfi?.id)"
            >
              {{ this.projectIdentifier }} {{ rfi?.rfi_no }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer text-left">
              {{
                rfi?.title.length > 25
                  ? (rfi?.title | slice : 0 : 25) + "..."
                  : rfi?.title
              }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer text-left"
              style="text-align: center"
            >
              {{ rfi?.issue_date }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto text-left"
              style="text-align: center"
            >
              {{ rfi?.response_date }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{
                rfi?.subject.length > 25
                  ? (rfi?.subject | slice : 0 : 25) + "..."
                  : rfi?.subject
              }}
            </td>

            <!-- DropDown Menu -->
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer text-center">
              <button mat-button [matMenuTriggerFor]="menu">
                <mat-icon class="text-[#000000]">more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openView(rfi?.id)">
                  <mat-icon style="color: #4caf50; font-size: 24px !important"
                    >visibility</mat-icon
                  >
                  <span style="margin-left: 10px">View Details</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<app-add-rfi
  [isDialogOpen]="isDialogOpen"
  (loadRfiData)="loadRfiData()"
></app-add-rfi>
